enum Descriptions {
  LAB_FOOTER_SHOW_QR = "QR will be shown on Default And Bordered templates just above where footer was.",
  LAB_REMARKS = "The lab remarks is shown below the signature block in default, bordered and A5 template while it is displayed above the signature block in other templates",
  AUTHORIZED_SIGNATURE = "The right block overrides the left block for authorized signature.",
  PAYMENT_PROOF = "Payment proof can be a scan copy or photo of deposited voucher.",
  LANDLINE_NUMBER_FORMAT = "The landline number should precede with area code and a hyphen. For Kathmandu, the number should be entered starting with 01-"
}

export default Descriptions;
